<template>
  <div>
    <div>
      <div class="searchArea">
        <a-select v-model:value="inputs.clubId" placeholder="门店" style="width: 275px;">
          <a-select-option v-for="item in clubList" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>

        <a-button type="primary" shape="circle" @click="search('')">
          <template #icon>
            <SearchOutlined />
          </template>
        </a-button>
        <a-button style="margin-left: 10px" type="primary" @click="showModal()">
          <template #icon>
            <PlusOutlined />
          </template>
          新建预约
        </a-button>
      </div>

      <a-table class="ant-table-striped" :columns="columns" :data-source="data" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="date" :scroll="{ x: 500 ,y:'66vh'}" :pagination="false">
        <template #date=" { text, record }">
          <a @click="tabsName({name:'单日预约管理',query:{date:text,clubId:inputs.clubId}})"> {{text}}</a>
        </template>
        <template v-for="col in employeeList" #[col.id]="{ text, record }" :key="col">
          <div v-if="record?.doctorCountMap && record?.doctorCountMap[col.id]">
            <div>
              {{record.doctorCountMap[col.id]?record.doctorCountMap[col.id]:'匿名'}}
            </div>
          </div>
        </template>
      </a-table>

    </div>

  </div>
  <addAppointment v-model="visible" :date="inputs.date" :clubList="clubList" :clubId="inputs.clubId" />
</template>

<style scoped>
.statusList {
  display: flex;
  background-color: #fff;
}
.status {
  padding: 5px 15px;
  background-color: #dbdbdb;
  transition: 0.2s all;
  border-radius: 10px;
  color: #fff;
  margin: 0px 5px 20px;
  cursor: pointer;
}

.table_status {
  color: #fff;
  /* background-color: #FDD100; */
  font-size: 20px;
  border-radius: 3px;
  max-width: 300px;
  margin-bottom: 3px;
  position: relative;
}

.customer:before,
.club:after {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  border: 1px solid #fff;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-size: 12px;
}

.customer:before {
  content: "客";
  left: 5px;
}

.club:after {
  content: "拓";
  right: 5px;
}
.status.focus {
  background-color: #c90916 !important;
  color: #fff;
  cursor: default;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.online {
  background: #40a9ff;
  border-color: #40a9ff;
}

.offline {
  background: #979596;
  border-color: #979596;
}
</style>

<script>
import {
  SearchOutlined,
  PlusOutlined,
  DownloadOutlined,
  CheckCircleFilled,
  WarningFilled,
  FormOutlined
} from "@ant-design/icons-vue";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { Search, ClubList, EmployeeList } from "/src/api/businessManage/summary.js";
import addAppointment from "/src/components/businessManage/addAppointment.vue";
export default {
  components: {
    SearchOutlined,
    PlusOutlined,
    DownloadOutlined,
    locale,
    CheckCircleFilled,
    WarningFilled,
    FormOutlined,
    addAppointment
  },
  name: "预约一览",
  data() {
    return {
      id: undefined,
      selectedRow: {},
      visible: false,
      currentStatus: "全部",
      inputs: {
        date: undefined,
        clubId: undefined, // 保持统一
      },
      clubList: [],

      labelCol: {
        span: 6,
      },
      employeeList: [],
      wrapperCol: {
        span: 14,
      },
      columns: [],
      data: [],

      // doExcel: doExcel
    };
  },
  created() { },
  mounted() {
    this.init()
  },
  activated() {
    if (localStorage.getItem("refrashProject") == "true") {
      // this.search(1);
    }
    localStorage.setItem("refrashProject", false);
  },
  methods: {
    init() {
      this.getClubList()
    },
    showModal() {
      this.visible = true
    },
    async getClubList() {
      let res = await ClubList();
      if (res.errCode == 0) {
        // 1. 数据映射
        this.clubList = res.data.map(item => {
          return {
            ...item,
            id: item.id || item.clubId,
            name: item.name || item.clubName,
            clubId: item.clubId || item.id,
            clubName: item.clubName || item.name
          }
        });

        // 2. 默认选中逻辑：如果只有一个门店，则默认选中
        if (this.clubList.length === 1) {
          this.inputs.clubId = this.clubList[0].id;

          // 3. 自动触发搜索（可选，建议添加）
          // 只有在选中的情况下才自动搜索，减少用户点击
          this.search();
        }
      }
    },

    resetForm() {
      this.inputs = {
        name: undefined,
        gender: undefined,
        isStandard: undefined,
      }
    },
    tabsName(tabName) {
      console.log(tabName.query);

      this.$store.commit("changePage", { name: tabName.name, query: tabName.query });
    },
    async search(pagination) {
      let _this = this;
      // 修正 inputs.id 为 inputs.clubId
      if (!this.inputs.clubId) {
        this.$message.error("请选择门店", function () { });
        return
      }
      let res = await EmployeeList({ clubId: this.inputs.clubId, position: "医生" });
      if (res.errCode == 0) {
        this.employeeList = res.data
        this.columns = [{
          title: "日期",
          dataIndex: "date",
          width: "100px",
          fixed: "left",
          slots: {
            customRender: "date"
          }
        }]
        //employeeList.name员工名称作为 thead,修改columns
        this.employeeList.forEach(item => {
          this.columns.push({
            title: item.name,
            dataIndex: item.id,
            width: "150px",
            slots: {
              customRender: item.id
            }
          })
        });

      } else {
        this.$message.error("医生列表查询失败", function () { });
        return
      }

      let params = {
        clubId: this.inputs.clubId, // 修正
        date: this.inputs.date ? this.inputs.date.format("YYYY-MM-DD") : undefined,
      };
      let res2 = await Search(params)
      if (res2.errCode == 0) {

        this.data = res2.data;
        // console.log("this.data", this.data);

      } else {
        this.$message.error("查询失败", function () { });
      }

      // console.log("this.columns", this.columns);

    },
    selectStatus(status) {
      this.statusList.forEach(item => {
        item.focus = false
      })
      status.focus = true
      this.currentStatus = status.name
    },


  }
};
</script>